import { BookOpen, Code, Activity, MessageCircle, Keyboard, ExternalLink, HelpCircle } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@shared/components/ui/popover'
import { Button } from '@shared/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@shared/components/ui/tooltip'
import { Separator } from '@shared/components/ui/separator'

const helpLinks = [
  { icon: BookOpen, label: 'Documentation', href: '#', external: true },
  { icon: Code, label: 'API Reference', href: '#', external: true },
  { icon: Activity, label: 'Status Page', href: '#', external: true },
  { icon: MessageCircle, label: 'Support', href: '#', external: true },
]

export function TopBarHelp() {
  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <HelpCircle className="h-4 w-4" />
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>Help</TooltipContent>
      </Tooltip>

      <PopoverContent align="end" className="w-[220px] p-1.5">
        <div className="space-y-0.5">
          {helpLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? '_blank' : undefined}
              rel={link.external ? 'noopener noreferrer' : undefined}
              className="flex items-center gap-2.5 px-2.5 py-2 text-sm rounded-md transition-colors hover:bg-muted text-foreground"
            >
              <link.icon className="h-4 w-4 text-muted-foreground shrink-0" />
              <span className="flex-1">{link.label}</span>
              {link.external && <ExternalLink className="h-3 w-3 text-muted-foreground/50" />}
            </a>
          ))}
          <Separator className="my-1" />
          <button
            onClick={() => {
              // Trigger the keyboard shortcut help (Shift+?)
              window.dispatchEvent(new KeyboardEvent('keydown', { key: '?', shiftKey: true }))
            }}
            className="flex items-center gap-2.5 px-2.5 py-2 text-sm rounded-md transition-colors hover:bg-muted text-foreground w-full"
          >
            <Keyboard className="h-4 w-4 text-muted-foreground shrink-0" />
            <span className="flex-1 text-left">Keyboard Shortcuts</span>
            <kbd className="text-[10px] opacity-40 font-mono">?</kbd>
          </button>
        </div>
      </PopoverContent>
    </Popover>
  )
}
